var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C9C9C9;}\n\t.st1{fill:#303030;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st0",
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,5.4c0.6-0.1,1.1-0.6,1.1-1.3C6.3,3.5,5.8,3.1,5.3,3C4.6,3.1,4.2,3.7,4.2,4.3C4.3,4.9,4.7,5.3,5.3,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,5.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1C9.6,3.1,9.1,3.7,9.2,4.3C9.2,4.9,9.6,5.3,10.2,5.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,5.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C14.1,4.9,14.6,5.3,15.1,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,5.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C19.1,4.9,19.5,5.3,20.1,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,5.4c0.6-0.1,1.1-0.6,1.1-1.3C26,3.5,25.5,3.1,25,3c-0.6,0.1-1.1,0.6-1.1,1.3C24,4.9,24.4,5.3,25,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,9.8c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1C4.6,7.5,4.2,8.1,4.2,8.7C4.3,9.3,4.7,9.7,5.3,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,9.8c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1C9.6,7.5,9.1,8.1,9.2,8.7C9.2,9.3,9.6,9.7,10.2,9.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,9.8c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C14.1,9.3,14.6,9.7,15.1,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,9.8c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C19.1,9.3,19.5,9.7,20.1,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,9.8c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3C24,9.3,24.4,9.7,25,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,14.2c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C4.3,13.7,4.7,14.1,5.3,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,14.2c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C9.2,13.7,9.6,14.1,10.2,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,14.2c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C14.1,13.7,14.6,14.1,15.1,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,14.2c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C19.1,13.7,19.5,14.1,20.1,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,14.2c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3C24,13.7,24.4,14.1,25,14.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,18.6c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C4.3,18.1,4.7,18.5,5.3,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,18.6c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C9.2,18.1,9.6,18.5,10.2,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,18.6c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C14.1,18.1,14.6,18.5,15.1,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,18.6c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C19.1,18.1,19.5,18.5,20.1,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,18.6c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3C24,18.1,24.4,18.5,25,18.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,23c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3C4.3,22.5,4.7,22.9,5.3,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,23c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3C9.2,22.5,9.6,22.9,10.2,23 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,23c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C14.1,22.5,14.6,22.9,15.1,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,23c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C19.1,22.5,19.5,22.9,20.1,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,23c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3C24,22.5,24.4,22.9,25,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,27.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C4.3,26.9,4.7,27.3,5.3,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,27.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C9.2,26.9,9.6,27.3,10.2,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,27.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C14.1,26.9,14.6,27.3,15.1,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,27.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3 C19.1,26.9,19.5,27.3,20.1,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,27.4c0.6-0.1,1.1-0.6,1.1-1.3c-0.1-0.6-0.5-1-1.1-1.1c-0.6,0.1-1.1,0.6-1.1,1.3C24,26.9,24.4,27.3,25,27.4 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.4e1d48e446b0bc6363fd9a67e3b1ce53.svg";
export { ForwardRef as ReactComponent };